import { ASSIGNMENT_TYPES } from '@/types/assignments';

// TODO remove this file once we replaced all mockdata
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMockPronounsAssignment: (assignmentId: number) => any = assignmentId => ({
  id: assignmentId,
  type: ASSIGNMENT_TYPES.MODEL_ASSESSMENT,
});
